import React from 'react';

import RiskScoreBadge from './RiskScoreBadge';

// MV2-2053: o score do cartão (ClearSale) sempre aparece quando existe, mesmo que o cartão
// tenha sido removido — esconder um score ruim tiraria do operador a informação de risco.
// Sem score, o PagBank (hasCard) decide: false = "No card"; true ou null (erro) = "Score unavailable".
const CardRiskScoreBadge = ({ loading, hasCard, data }) => (
  <RiskScoreBadge
    label='Card'
    loading={loading}
    data={data}
    emptyText={hasCard === false ? 'No card' : 'Score unavailable'}
  />
);

export default CardRiskScoreBadge;
